import "../../index35.css";
import { jsxs as r, jsx as i } from "react/jsx-runtime";
import { a as g } from "../../type-BFTbooL7.js";
import { _ as l } from "../../cs-piwRuCFZ.js";
import j from "../NumberOutput/index.js";
import S from "../ProgressBar/index.js";
const y = "_key-figure_1owjn_1", I = "_icon-section_1owjn_8", k = "_icon_1owjn_8", x = "_info-section-without-icon_1owjn_25", F = "_value_1owjn_31", b = "_description_1owjn_36", C = "_with-icon_1owjn_41", o = {
  keyFigure: y,
  iconSection: I,
  icon: k,
  infoSectionWithoutIcon: x,
  value: F,
  description: b,
  withIcon: C
};
function P(m) {
  const {
    className: d,
    children: c,
    contentClassName: u,
    value: _,
    compactValue: p,
    label: s,
    labelClassName: f,
    description: t,
    descriptionClassName: h,
    progress: a,
    progressTitle: v,
    progressDescription: N,
    icon: e,
    info: n,
    suffix: w
  } = m;
  return /* @__PURE__ */ r(
    "div",
    {
      className: l(
        o.keyFigure,
        !!e && o.withIcon,
        d
      ),
      children: [
        e && /* @__PURE__ */ r("div", { className: o.iconSection, children: [
          /* @__PURE__ */ i("div", { className: o.icon, children: e }),
          n && /* @__PURE__ */ i("div", { className: o.infoSection, children: n })
        ] }),
        !e && n && /* @__PURE__ */ i("div", { className: o.infoSectionWithoutIcon, children: n }),
        /* @__PURE__ */ i(
          j,
          {
            className: o.value,
            value: _,
            compact: p,
            suffix: w
          }
        ),
        s && /* @__PURE__ */ i("div", { className: f, children: s }),
        t && /* @__PURE__ */ i("div", { className: l(h, o.description), children: t }),
        g(a) && /* @__PURE__ */ i(
          S,
          {
            title: v,
            value: a,
            totalValue: 100,
            description: N
          }
        ),
        c && /* @__PURE__ */ i("div", { className: u, children: c })
      ]
    }
  );
}
export {
  P as default
};
